export default {

  getErrorMsg(err) {
    // NOTA: quando non c'è la rete, err.response è undefined
    //       quando la pagina non è trovata (404) "data" è vuoto
    //       quando da Api non passo "message" prendo "data"
    return (err.response && err.response.data ? (err.response.data.message || err.response.data) : err.message)
  },

  getDateIso() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000;
    var localISODate = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

    return localISODate
  },


  formatDateTime(d) {
    let year = "" + d.getFullYear();
    let month = "" + (d.getMonth() + 1);
    if (month.length == 1) {
      month = "0" + month;
    }
    let day = "" + d.getDate();
    if (day.length == 1) {
      day = "0" + day;
    }
    let hour = "" + d.getHours();
    if (hour.length == 1) {
      hour = "0" + hour;
    }
    let minute = "" + d.getMinutes();
    if (minute.length == 1) {
      minute = "0" + minute;
    }
    let second = "" + d.getSeconds();
    if (second.length == 1) {
      second = "0" + second;
    }

    return day + "/" + month + "/" + year + " " + hour + ":" + minute + ":" + second;
  },

  formatDate(d) {
    let year = "" + d.getFullYear();

    let month = "" + (d.getMonth() + 1);
    if (month.length == 1) {
      month = "0" + month;
    }

    let day = "" + d.getDate();
    if (day.length == 1) {
      day = "0" + day;
    }

    return day + "/" + month + "/" + year;
  },

  formatISODate(data) {
    // NOTA: la data deve essere passata in formato ISO (.toISOString())
    if (!data) return null;

    // Ricavo solo la data (primi 10 caratteri)
    data = data.substr(0, 10)

    const [year, month, day] = data.split("-");
    return `${day}/${month}/${year}`;
  },

  getMonth(data) {
    return (new Date(data).getMonth()) + 1
  },

  getYear(data) {
    return (new Date(data).getFullYear())
  },

  replaceAll(str, valCerca, valReplace) {
    // escape regexp special characters in search string
    valCerca = valCerca.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
    return str.replace(new RegExp(valCerca, 'g'), valReplace);
  },

  remove_first_character(element) {
    return element.substr(1, element.length)
  },

  remove_last_character(element) {
    return element.substr(0, element.length - 1)
  },

  getCodArticoloFormat(codArticolo) {

    if (!codArticolo)
      return ""

    let str = ""
    str = codArticolo.substring(0, 3)
    str += " "
    str += codArticolo.substring(3, 8)
    str += " "
    str += codArticolo.substring(8, 10)
    str += " "
    str += codArticolo.substring(10, 12)
    if (codArticolo.length >= 12) {
      str += " "
      str += codArticolo.substring(12, 14)
    }

    return str
  },

  getSconti(sc1, sc2, sc3) {
    let res = "";

    if (sc1 != 0) res += sc1.toString() + "+";
    if (sc2 != 0) res += sc2.toString() + "+";
    if (sc3 != 0) res += sc3.toString() + "+";

    if (res.length > 1) res = this.remove_last_character(res);

    return res;
  },

  convertiTestoGrassetto(valore) {
    //console.log(valore);

    let firstvariable = '"';
    let secondvariable = '"';

    var regExString = new RegExp(
      "(?:" + firstvariable + ")(.*?)(?:" + secondvariable + ")",
      "ig"
    );

    var testRE = regExString.exec(valore);
    if (testRE && testRE.length > 1) {
      //console.log(testRE[1]);

      valore = valore.replace(
        firstvariable + testRE[1] + secondvariable,
        "<b>" + testRE[1] + "</b>"
      );

    }

    return valore;
  },

  trimAll(text) {
    return text.toString().replace(/\s/g, '')
  },

  CordovaApp() {
    return !!window.cordova
  },

  groupBy(array, key) {
    // NOTA: l'index della result non parte da zero (ma in base al groupBy)
    //       groupBy come viene implementata da lodash

    const result = {};
    array.forEach(item => {
      if (!result[item[key]]) {
        result[item[key]] = [];
      }
      result[item[key]].push(item);
    });

    return result
  },

  groupByIndex(array, key) {

    let res = this.groupBy(array, key)

    return Object.keys(res).map(function (key) {
      return {
        key: key,
        values: res[key]
      };
    });
  },

  isNumber(str) {
    // NOTA: nel caso sia zero viene considerato come false
    if (!str && str.toString() != "0")
      return false

    if (this.trimAll(str).length == 0)
      return false

    return true

  },


  /* ----------------------------------------------- */
  /* ----------------.--- Update ---------------.--- */
  /* ----------------------------------------------- */
  async checkUpdate(url, autoUpdate) {

    if (url.length == 0) return false;

    try {
      // NOTA: nel caso di file statico aggiungo l'ora altrimenti prenderebbe il file dalla cache
      //       se invece nell'url passo una chiamata api non faccio nulla
      if (url.endsWith(".html")) {
        // NOTA: aggiungo l'ora altrimenti prenderebbe il file dalla cache
        url += location.href.indexOf("?") == -1 ? "?" : "&"
        url += "timeStamp=" + (new Date()).getTime();
      }


      let res = await fetch(url);

      let str = await res.text();


      let strFind = "/js/app.";

      // Cerco la versione
      let start = str.indexOf(strFind);
      if (start == -1)
        return false

      let hash = str.substring(
        start + strFind.length,
        start + strFind.length + 8
      );

      let vers = localStorage.getItem('version');

      // Controllo versione locale con quella di webpack
      if (vers && vers !== hash) {
        // Controllo autoaggiornamento
        if (autoUpdate) {
          localStorage.removeItem("version");
          window.location.reload();
        }
        return true
      } else {
        localStorage.setItem('version', hash);
      }
    } catch (error) {
      console.log(error);
    }

    return false
  }



}